import { render, staticRenderFns } from "./v-menu-new.vue?vue&type=template&id=53f18c60&scoped=true&"
import script from "./v-menu-new.vue?vue&type=script&lang=ts&"
export * from "./v-menu-new.vue?vue&type=script&lang=ts&"
import style0 from "./v-menu-new.vue?vue&type=style&index=0&id=53f18c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f18c60",
  null
  
)

export default component.exports